<template>
  <div class="p-2">
    <div class="row">
        <div class="col-12 text-center h3">
            {{ __('forms.peopleMedia.peopleSender.title') }}
        </div>
    </div>
    <div class="filters_typology_people row">
      <div class="col-6 form-group">
        <label>{{ __('forms.peopleMedia.peopleSender.personTypology') }}</label>
        <select
          v-model="typology_id"
          name="typology"
          @change="getPeople($event)"
          class="form-control"
        >
          <option value="null">---</option>
          <option v-for="row in people_typology" :key="row.id" :value="row.id">
            {{ row.name }}
          </option>
        </select>
      </div>      
      <div class="col-6 form-group">
        <label>Persona</label>
        <select
          v-model="person_id"
          name="person"
          @change="insertPerson($event)"
          class="form-control"
        >
          <option value="null">---</option>
          <option v-for="row in people_select" :key="row.id" :value="row.id">
            {{ row.fullName }}
          </option>
        </select>
      </div>
      <div class="col-12 form-group">
        <a href="#" class="btn btn-small" @click="addAllTypology()">
            {{ __('forms.peopleMedia.peopleSender.add_all') }}
        </a>
        <a href="#" class="btn btn-small" @click="destroyAllPeople()">
            {{ __('forms.peopleMedia.peopleSender.delete_all') }}
        </a>
         <a href="#" class="btn btn-small" @click="allSetFolderPermission()">
            {{ __('forms.peopleMedia.peopleSender.all_set_folder_visibility') }}
        </a>
        <a href="#" class="btn btn-small" @click="allResetFolderPermission()">
            {{ __('forms.peopleMedia.peopleSender.all_reset_folder_visibility') }}
        </a>
        <a href="#" class="btn btn-small" @click="setCheckAllPeople(1)">
            {{ __('forms.peopleMedia.peopleSender.set_check_all_people') }}
        </a>
        <a href="#" class="btn btn-small" @click="setCheckAllPeople(0)">
            {{ __('forms.peopleMedia.peopleSender.reset_check_all_people') }}
        </a>
        <span v-if="showLoader" class="float-right">
            <i class="fas fa-2x fa-spinner fa-spin"></i>&nbsp; {{ __('misc.loading') }}
        </span>
      </div>
    </div>       
    <div class='alert alert-warning'>
      <strong>
        <i class="fa fa-exclamation-triangle"></i>&nbsp;
          {{ __('forms.peopleMedia.peopleSender.warning') }}
      </strong> 
      <p>{{ __('forms.peopleMedia.peopleSender.warning_message') }}</p>

    </div>  
        <hr />
    <div class="people-reader">
      <div class="people-reader__table-wrapper">
        <table class="people-reader__table">
          <thead>
            <tr>
              <th style="width: 40px;"></th>
              <th style="width: 60px;">{{ __('forms.peopleMedia.peopleSender.active_email') }}</th>
              <th>{{ __('forms.peopleMedia.peopleSender.person') }}</th>
              <th>{{ __('forms.peopleMedia.peopleSender.personTypology') }}</th>
              <th>{{ __('forms.peopleMedia.peopleSender.can_see_folder') }}</th>
              <th>{{ __('forms.peopleMedia.peopleSender.can_see_file') }}</th>
              <th>{{ __('forms.peopleMedia.peopleSender.feedback') }}</th>
              <th>{{ __('forms.peopleMedia.peopleSender.email_send_at') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in people_reader" :key="row.id">
              <td>
                <div id="trash-button-container">
                  <a href="#" @click="deleteRow(row.id)"
                    ><i  class="fa fa-trash"></i>
                  </a>
                  <input
                    type="hidden"
                    :value="row.id"
                    :name="'person[' + row.person_id + ']'"
                  />
                </div>
              </td>

              <td v-if="row.flag_person_mail">
                <label style="color: green; font-size: 40px">&bull;</label>
              </td>
              <td v-else>
                <label style="color: red; font-size: 40px">&bull;</label>
              </td>

              <td>{{ row.name }}</td>
              <td>{{ row.typology }}</td>

              <td>
                <input
                  type="checkbox"
                  value="1"
                  :name="'person[' + row.id + '][can_see_folder]'"
                  @change="updateFolderVisibility($event, row.id)"
                  v-model="row.can_see_folder"
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  value="1"
                  :name="'person[' + row.id + '][can_see]'"
                  @change="updatePerson($event, row.id, 'can_see')"
                  v-model="row.can_see"
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  value="1"
                  :name="'person[' + row.id + '][flag_email_feedback]'"
                  @change="updatePerson($event, row.id, 'flag_email_feedback')"
                  v-model="row.flag_email_feedback"
                />
              </td>
              <td>{{ row.sent_at }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    this.getReader();
    this.startPolling();
  },
  beforeDestroy() {
    this.stopPolling();
  },
  data() {
    return {
      typology_id: null,
      person_id: null,
      people_reader: {},
      people_select: {},
      showLoader: false,
      pollingInterval: null,
    };
  },
  props: {
    api_url: {
      type: String,
      required: true,
    },
    people_typology: {
      type: Array,
      required: true,
    },
    media_id: {
      type: Number,
      required: true,
    },
    type: {
      type: Number,
      required: true,
    },
  },
  methods: {
    getReader() {

      this.showLoader = true;
      axios
        .get(this.api_url)
        .then((response) => {
          this.people_reader = response.data;
        })
        .catch(function (error) {
          alert(error);
        });

        this.showLoader = false;
    },
    destroyAllPeople() {

      this.showLoader = true;
      axios
        .delete(
          "/people-medias-destroy-all-people/" +
            this.media_id +
            "/media/" +
            this.type +
            "/type"
        )
        .then((response) => {
          this.showLoader = false;
          this.getReader();
        });
    },
    addAllTypology() {
      if (this.typology_id !== null) {
        this.showLoader = true;
        axios
          .post(
            "/people-media/add-all-people-typology/" +
              this.media_id +
              "/media/" +
              this.type +
              "/type/" +
              this.typology_id +
              "/typology"
          )
          .then((response) => {
            if (response.data.async) {
              this.startPolling();
            } else {
              this.showLoader = false;
              this.getReader();
            }
          });
      }
    },
    startPolling() {
      this.stopPolling();
      this.pollingInterval = setInterval(() => {
        axios
          .get('/api/people-media/' + this.media_id + '/pending-jobs', {
            params: {
              type: this.type,
            },
          })
          .then((response) => {
            if (!response.data.running) {
              this.stopPolling();
              this.showLoader = false;
              this.getReader();
            } else {
              this.getReader();
              this.showLoader = true;
            }
          })
          .catch(() => {
            this.stopPolling();
            this.showLoader = false;
          });
      }, 1000);
    },
    stopPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    },
    getPeople(event) {
      if (event.target.value == "null") {
        this.people_select = [];
        return;
      }

      this.typology_id = event.target.value;
      axios
        .get(
          "/api/people-medias-for-typology/" +
            this.typology_id +
            "/people-typology"
        )
        .then((response) => {
          this.people_select = response.data;
        })
        .catch(function (error) {
          alert(error);
        });
    },
    deleteRow(row_id) {
      axios
        .delete("/people-medias/" + row_id, {
          params: { person_media: row_id },
        })
        .then((response) => {
          this.getReader();
        });
    },
    insertPerson(event) {
      if (event.target.value === 0) {
        return;
      }
      axios
        .post("/people-media/action/store-person-media", {
          person_id: event.target.value,
          media_id: this.media_id,
          type: this.type,
        })
        .then((response) => {
          this.getReader();
          this.typology_id = null;
          this.people_select = [];
        });
    },
    updatePerson(event, row_id, field) {
      axios
        .put("/people-medias/" + row_id, {
          field: field,
          value: event.target.checked,
          person_media: row_id,
        })
        .then((response) => {});
    },
    
    updateFolderVisibility(event, row_id) {
      axios
        .put("/update-people-media-folder-visibility/" + row_id, {
          visibility: event.target.checked,
          person_media: row_id,
        })
        .then((response) => {});
    },
    
    setCheckAllPeople(set) {

      this.showLoader = true;
      axios
        .put("/people-medias-set-check-all/" + this.media_id + "/media", {
          set: set,
          type: this.type,
        })
        .then((response) => {
          this.showLoader = false;
          this.getReader();
        });
    },
    allSetFolderPermission(){

      this.showLoader = true;

      Vue.swal
        .fire({
          title: "Sicuro/a di voler procedere?",
          text: "Altererai la visibilità di tutti i file contenuti in questa cartella.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Conferma",
          cancelButtonText: "Annulla",
        })
        .then((result) => {
          console.log(result);
          if (result.value) {
            axios
              .put('/people-media/action/set-all-people-folder-visibility/'+this.media_id,{})
              .then((data) => {
                this.showLoader = false;
                this.getReader();
              })
              .catch((err) => {
                console.log(err);
                this.showLoader = false;
                Vue.swal.fire("Ops...qualcosa è andato storto!");
              });
          }
        }).catch((error) => {          
           
        });
    },
    allResetFolderPermission(){
      
      this.showLoader = true;
        Vue.swal
        .fire({
          title: "Sicuro/a di voler procedere?",
          text: "Altererai la visibilità di tutti i file contenuti in questa cartella.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Conferma",
          cancelButtonText: "Annulla",
        })
        .then((result) => {
          
          
          if (result.value) {
            axios
              .put('/people-media/action/reset-all-people-folder-visibility/'+this.media_id,{})
              .then((data) => {
                this.showLoader = false;
                this.getReader();
              })
              .catch((err) => {
                console.log(err);
                this.showLoader = false;
                Vue.swal.fire("Ops...qualcosa è andato storto!");
              });
          }
        }).catch((error) => {          
           
        });
    },
  },
};
</script>

<style>
.custom-actions button.ui.button {
  padding: 8px 8px;
}
.custom-actions button.ui.button > i.icon {
  margin: auto !important;
}
#trash-button-container{
  margin-top: 1.7rem;
}

.people-reader {
  margin-top: 1rem;
}

.people-reader__table-wrapper {
  max-height: 40vh;          
  overflow-y: auto;
  border: 1px solid #DFE6F6;
  border-radius: 4px;
}

.people-reader__table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.people-reader__table th,
.people-reader__table td {
  padding: 0.4rem 0.5rem;
  vertical-align: middle;
}

.people-reader__table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: #f7f9fb; 
  border-bottom: 1px solid #DFE6F6;
}


</style>
